// Parcel Geometry Module - handles side length labels for parcels
let map = null;
let sideInfoDataSource = null;
let sideInfoLayer = null;

// Initialize the module
function initialize(mapInstance) {
    map = mapInstance;
}

// Display side length labels for a parcel
function displaySideLabels(sideInfo) {
    if (!map || !sideInfo || !Array.isArray(sideInfo) || sideInfo.length === 0) {
        return;
    }

    // Create data source if it doesn't exist
    if (!sideInfoDataSource) {
        sideInfoDataSource = new atlas.source.DataSource('parcel-side-info-source');
        map.sources.add(sideInfoDataSource);
    }

    // Build point features for each side midpoint with label
    const labelFeatures = [];
    
    for (const side of sideInfo) {
        const lengthFeet = side.lengthFeet || side.LengthFeet || 0;
        const midLng = side.midpointLongitude || side.MidpointLongitude || 0;
        const midLat = side.midpointLatitude || side.MidpointLatitude || 0;
        const isFront = side.isFront || side.IsFront || false;

        // Format length: show feet, round to 1 decimal place
        const lengthText = `${lengthFeet.toFixed(1)} ft`;
        
        // If this is a front side, add "Front" label
        const labelText = isFront ? `Front\n${lengthText}` : lengthText;

        // Create point with coordinates as array [lng, lat]
        const midpoint = [midLng, midLat];
        const labelFeature = new atlas.data.Feature(
            new atlas.data.Point(midpoint),
            {
                label: labelText,
                sideIndex: side.sideIndex || side.SideIndex || 0,
                lengthFeet: lengthFeet,
                isFront: isFront
            }
        );

        labelFeatures.push(labelFeature);
    }

    if (labelFeatures.length > 0) {
        // Create layer if it doesn't exist
        if (!sideInfoLayer) {
            sideInfoLayer = new atlas.layer.SymbolLayer(sideInfoDataSource, 'parcel-side-info-layer', {
                textOptions: {
                    textField: ['get', 'label'],
                    size: 14,
                    font: ['StandardFont-Bold'],
                    color: '#C77BFF',
                    haloColor: '#000000',
                    haloWidth: 2,
                    offset: [0, 0]
                },
                iconOptions: {
                    image: 'none'
                }
            });
            map.layers.add(sideInfoLayer);
        }
        
        // Use setShapes to replace all features atomically (avoids race conditions)
        sideInfoDataSource.setShapes(labelFeatures);
    }
}

// Clear all side labels
function clearSideLabels() {
    if (sideInfoDataSource) {
        sideInfoDataSource.clear();
    }
}

// Cleanup: remove layers and data sources
function cleanup() {
    clearSideLabels();

    if (sideInfoLayer && map) {
        map.layers.remove(sideInfoLayer);
        sideInfoLayer = null;
    }

    if (sideInfoDataSource && map) {
        map.sources.remove(sideInfoDataSource);
        sideInfoDataSource = null;
    }
}

// Public API
const MapParcelGeometry = {
    initialize: initialize,
    displaySideLabels: displaySideLabels,
    clearSideLabels: clearSideLabels,
    cleanup: cleanup
};

// Export for ES6 modules
export default MapParcelGeometry;

// Make it globally accessible for backward compatibility
window.MapParcelGeometry = MapParcelGeometry;
